import type {CapabilityNameToComponentMap} from './types';
import Pickupability from './components/Pickupability.svelte';
import VisitPickupability from './components/VisitPickupability.svelte';
import StandardOrderability from './components/StandardOrderability.svelte';
import StandardVisitOrderability from './components/StandardVisitOrderability.svelte';
import SlotVisitOrderability from './components/SlotVisitOrderability.svelte';
import StandardReservability from './components/StandardReservability.svelte';
import StandardVisitReservability from './components/StandardVisitReservability.svelte';
import PalmknihyLoanability from './components/PalmknihyLoanability.svelte';
import PalmknihyAudioLoanability from './components/PalmknihyAudioLoanability.svelte';
import PalmknihyPdfLoanability from './components/PalmknihyPdfLoanability.svelte';
import FlexibooksLoanability from './components/FlexibooksLoanability.svelte';
import LevnaknihovnaLoanability from './components/LevnaknihovnaLoanability.svelte';
import MailRequestability from './components/MailRequestability.svelte';
import SeekingRequestability from './components/SeekingRequestability.svelte';
import Downloadability from './components/Downloadability.svelte';

export const CAPABILITY_TO_COMPONENT_MAP: CapabilityNameToComponentMap = {
    'pickupability': {
        cssClass: 'loan-request-option-pickup',
        component: Pickupability
    },
    'visitPickupability': {
        cssClass: 'loan-request-option-visit-pickup',
        component: VisitPickupability
    },
    'standardOrderability': {
        cssClass: 'loan-request-option-order',
        component: StandardOrderability
    },
    'standardVisitOrderability': {
        cssClass: 'loan-request-option-visit-order',
        component: StandardVisitOrderability
    },
    'slotVisitOrderability': {
        cssClass: 'loan-request-option-visit-order',
        component: SlotVisitOrderability
    },
    'standardReservability': {
        cssClass: 'loan-request-option-reservation',
        component: StandardReservability
    },
    'standardVisitReservability': {
        cssClass: 'loan-request-option-visit-reservation',
        component: StandardVisitReservability
    },
    'palmknihyLoanability': {
        cssClass: 'loan-request-option-palknihy',
        component: PalmknihyLoanability
    },
    'palmknihyAudioLoanability': {
        cssClass: 'loan-request-option-palmknihy-audio',
        component: PalmknihyAudioLoanability
    },
    'palmknihyPdfLoanability': {
        cssClass: 'loan-request-option-palmknihy-pdf',
        component: PalmknihyPdfLoanability
    },
    'flexibooksLoanability': {
        cssClass: 'loan-request-option-flexibooks',
        component: FlexibooksLoanability
    },
    'levnaknihovnaLoanability': {
        cssClass: 'loan-request-option-levnaknihovna',
        component: LevnaknihovnaLoanability
    },
    'mailRequestability': {
        cssClass: 'loan-request-option-email',
        component: MailRequestability
    },
    'seekingProvidability': {
        cssClass: 'loan-request-option-mvs',
        component: SeekingRequestability
    },
    'downloadability': {
        cssClass: 'loan-request-option-download',
        component: Downloadability
    }
};